import React from 'react';

export default function NoMatch() {
    return <main style={{ padding: '120px 24px', textAlign: 'center' }}>
        <h1>Page introuvable</h1>
        <p>La page demandée n’existe pas.</p>
        <a href="/">Retour à l’accueil</a>
    </main>;
}
